/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LabelFilter,
    LabelFilterFromJSON,
    LabelFilterFromJSONTyped,
    LabelFilterToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutoRebaseConfig
 */
export interface AutoRebaseConfig {
    /**
     * 
     * @type {boolean}
     * @memberof AutoRebaseConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {LabelFilter}
     * @memberof AutoRebaseConfig
     */
    labelFilter?: LabelFilter;
    /**
     * Approves workflow runs awaiting approval on the merge commits Kapybro pushes when rebasing.
     * @type {boolean}
     * @memberof AutoRebaseConfig
     */
    approveWorkflowRuns?: boolean;
}

export function AutoRebaseConfigFromJSON(json: any): AutoRebaseConfig {
    return AutoRebaseConfigFromJSONTyped(json, false);
}

export function AutoRebaseConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoRebaseConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'labelFilter': !exists(json, 'labelFilter') ? undefined : LabelFilterFromJSON(json['labelFilter']),
        'approveWorkflowRuns': !exists(json, 'approveWorkflowRuns') ? undefined : json['approveWorkflowRuns'],
    };
}

export function AutoRebaseConfigToJSON(value?: AutoRebaseConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'labelFilter': LabelFilterToJSON(value.labelFilter),
        'approveWorkflowRuns': value.approveWorkflowRuns,
    };
}

